import { useCallback, useMemo } from 'react';
import { useBlog } from '../context/BlogContext';
import { usePortfolio } from '../context/PortfolioContext';
import { localizePost, localizeProject } from '../i18n/content';

// Admins edit originals and translations separately. Public pages use these
// views even when the visitor is signed in as an admin.
export function useLocalizedBlog() {
  const { posts: originals, getPostBySlug: getOriginal, loading, error } = useBlog();
  const posts = useMemo(() => originals.map(post => localizePost(post)), [originals]);
  const getPostBySlug = useCallback(async (slug: string) => {
    const post = await getOriginal(slug);
    return post ? localizePost(post) : undefined;
  }, [getOriginal]);
  return { posts, getPostBySlug, loading, error };
}

export function useLocalizedPortfolio() {
  const { projects: originals, getProjectBySlug: getOriginal, loading, error } = usePortfolio();
  const projects = useMemo(() => originals.map(project => localizeProject(project)), [originals]);
  const getProjectBySlug = useCallback(async (slug: string) => {
    const project = await getOriginal(slug);
    return project ? localizeProject(project) : undefined;
  }, [getOriginal]);
  return { projects, getProjectBySlug, loading, error };
}
